import {useEffect, useRef} from "react";

/**
 * Custom React hook that debounces the execution of a callback function.
 *
 * @param {Function} callback The function to be debounced. Defaults to an empty function.
 * @param {Array} deps An array of dependencies to watch for changes. When a dependency changes,
 * @param {number} delay The delay in milliseconds before executing the callback. Defaults to 200.
 * the callback will be debounced and executed after the delay.
 */
const useEffectWithDebounce = (callback = () => {
}, deps = [], delay = 200) => {
  const timeoutRef = useRef(null);
  useEffect(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      if (typeof callback === "function") {
        callback();
      }
    }, delay);
    return () => {
      clearTimeout(timeoutRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...deps]);
}

export default useEffectWithDebounce;